define('views/shared/form/input/text_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/text_component.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'form-input',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {
            'keyup input': 'handleTextInput'
        },

        initialize: function(options){
            options = options || {};

            this.context = options.context;

            this.field = options.field;

            this.empty = true;

            this.is_valid = false;
            this.error = false;

            this.soft_error = false;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            // if autocomplete is false and we're in chrome
            if (!this.field.autocomplete && window.chrome) {
                this.field.autocomplete = 'autocomplete-off-' + (new Date()).getTime();
            }

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            this.render();
            
        },

        updateValue: function(val){
            this.$el.find('input').val(val);
            this.handleTextInput();
        },

        getValue: function(){

            if(this.field.encrypt){
                return encrypt(this.$el.find('input').val());
            } else {
                return this.$el.find('input').val();
            }

        },

        handleTextInput: function(e){
            var text = this.$el.find('input').val();

            if(text != '' && text){

                this.is_valid = true;

                this.empty = false;
                
                if(this.context && _.isFunction(this.context.updateStatus)){
                    this.context.updateStatus();
                }
                
                this.removeError();

            } else {
                this.empty = true;
            }

        },

        showError: function(){
            this.error = true;
            this.$el.find('.js-form-input-feedback').html(this.field.error);
        },

        removeError: function(){
            this.error = false;
            this.$el.find('.js-form-input-feedback').html('');
            // this.$el.removeClass('outline-error');
            // this.soft_error = false;
        },

        showDataMatchingError: function(){
            this.$el.addClass('outline-error');
            this.soft_error = true;
        },

        close: function(){}
    });
});

